export default {
    ADD_ROUTING_RULE: 'ADD_ROUTING_RULE',
    EDIT_ROUTING_RULE: 'EDIT_ROUTING_RULE',
    DELETE_ROUTING_RULE: 'DELETE_ROUTING_RULE',
    UPDATE_FULL_ROUTING_RULES: 'UPDATE_FULL_ROUTING_RULES',
    RESET_ROUTING_RULES: "RESET_ROUTING_RULES"
};
